import React from 'react';
import { motion } from 'framer-motion';
import { History } from 'lucide-react';
import { SectionHeader } from '../shared/SectionHeader';
import { CollapsibleSection } from '../shared/CollapsibleSection';
import { ChannelRevenuePivot } from './ChannelRevenuePivot';
import { MonthlyPerformanceAccordion } from './MonthlyPerformanceAccordion';
import { PlatformCategoryBreakdown } from './PlatformCategoryBreakdown';
import { GaMonthlySummary } from './GaMonthlySummary';
import { WeeklyHeatmap } from './WeeklyHeatmap';
import { WeekOverWeekSummary } from './WeekOverWeekSummary';

export function HistoricalData({
  monthlyPerformanceData, monthlyPlatformCategoryData, channelMonthlyRevenue,
  gaMonthlySummary, weeklyRevenueByWeekday, weeklyWoWSummary,
  allCostsByMonth, totalAllCosts, weeklyMetric, onWeeklyMetricChange,
  isVisible,
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-50px' }}
      transition={{ duration: 0.5 }}
      className="mb-6"
    >
      <SectionHeader title="Historical Data" icon={History} subtitle="All-time performance metrics" />

      <CollapsibleSection title="Channel Revenue Pivot" sectionKey="hist-channel-revenue">
        <ChannelRevenuePivot channelMonthlyRevenue={channelMonthlyRevenue} />
      </CollapsibleSection>

      <CollapsibleSection title="Monthly Performance" sectionKey="hist-monthly-perf">
        <MonthlyPerformanceAccordion monthlyPerformanceData={monthlyPerformanceData} />
      </CollapsibleSection>

      {isVisible && (
        <CollapsibleSection title="Platform Category Breakdown" sectionKey="hist-platform-cat">
          <PlatformCategoryBreakdown monthlyPlatformCategoryData={monthlyPlatformCategoryData} />
        </CollapsibleSection>
      )}

      <CollapsibleSection title="GA Monthly Summary" sectionKey="hist-ga-monthly">
        <GaMonthlySummary gaMonthlySummary={gaMonthlySummary} allCostsByMonth={allCostsByMonth} totalAllCosts={totalAllCosts} />
      </CollapsibleSection>

      <CollapsibleSection title="Weekly Heatmap" sectionKey="hist-weekly-heatmap">
        <WeeklyHeatmap
          weeklyRevenueByWeekday={weeklyRevenueByWeekday}
          weeklyMetric={weeklyMetric}
          onWeeklyMetricChange={onWeeklyMetricChange}
        />
      </CollapsibleSection>

      <CollapsibleSection title="Week-over-Week Summary" sectionKey="hist-wow">
        <WeekOverWeekSummary weeklyWoWSummary={weeklyWoWSummary} weeklyMetric={weeklyMetric} />
      </CollapsibleSection>
    </motion.div>
  );
}
